export default {
  home: 'Home',
  organization: 'Organization',
  personal: 'Personal',
};
